import sitecore from 'Global/Shared/Components/Sitecore/Sitecore';

class ImageToInlineSvg {
	constructor(element) {
		this.element = element;

		this.initialize();
	}

	convert() {
		const imageClass = this.element.className;
		const imageId = this.element.id;

		fetch(this.srcFromSitecore()).then((response) => {
			return response.text();
		}).then((text) => {
			var parser = new DOMParser();
			var xmlDoc = parser.parseFromString(text, 'text/xml');

			var svg = xmlDoc.getElementsByTagName('svg')[0];
			if (svg === undefined) return;

			if (typeof imageId !== 'undefined') {
				svg.setAttribute('id', imageId);
			}
			if (typeof imageClass !== 'undefined') {
				svg.setAttribute('class', imageClass);
			}
			svg.removeAttribute('xmlns:a');
			if(!svg.getAttribute('viewBox') && svg.getAttribute('height') && svg.getAttribute('width')) {
				svg.setAttribute('viewBox', '0 0 ' + svg.getAttribute('height') + ' ' + svg.getAttribute('width'));
			}
			if (this.element.parentNode !== null) {
				this.element.parentNode.replaceChild(svg, this.element);
			}
		});
	}

	initialize() {
		if (sitecore.isEdit()) return;

		this.convert();
	}

	srcFromSitecore() {
		const imageSrc = this.element.src;

		if (imageSrc.indexOf('/-/') == -1) {
			return imageSrc;
		}

		const splittedSrc = imageSrc.split('/-/');
		return '/-/' + splittedSrc[1];
	}
}

export default ImageToInlineSvg;
